module.exports = __webpack_public_path__ + "img/hsr.26223fea.svg";